import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M15.153 4.284c-1.174-.436-1.695-2.18-3.033-2.28a2 2 0 0 0-.24 0c-1.337.1-1.858 1.844-3.032 2.28-1.243.461-2.943-.484-3.995.568-1.013 1.013-.117 2.778-.569 3.995-.461 1.245-2.393 1.76-2.28 3.273.101 1.337 1.845 1.859 2.28 3.033.452 1.217-.444 2.982.569 3.995 1.052 1.052 2.752.107 3.995.568 1.173.436 1.695 2.18 3.033 2.28q.12.009.239 0c1.338-.1 1.86-1.844 3.033-2.28 1.217-.451 2.982.445 3.995-.568 1.087-1.087.04-2.85.614-4.106.53-1.156 2.344-1.698 2.234-3.161-.1-1.338-1.843-1.86-2.28-3.034-.46-1.243.484-2.942-.568-3.995s-2.752-.107-3.995-.568Z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.242 16v-4c0-.471 0-.707-.146-.854-.147-.146-.382-.146-.854-.146"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11.992 8h.01"
    }, null, -1)
  ])]);
}
const InformationDiamondStrokeRoundedIcon = { render };
export {
  InformationDiamondStrokeRoundedIcon as default,
  render
};
//# sourceMappingURL=information-diamond-stroke-rounded.svg.js.map
